module.exports = __webpack_public_path__ + "static/img/87015A_2_3_R_20191001_LC.a32dea3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/87015A_2_3_R_20191001_LC.png
// module id = pd3W
// module chunks = 0